import { createImgSubstitutesGetter } from '../createImgSubstitutesGetter';
import getCDNImage from '../getCDNImage';

const removeSizeExtFromImgSrc = (src) => src.replace(/.[0-9]+x[0-9]+./, '.');
const transformSrc = (transformer) => (item) => ({ ...item, src: transformer(item.src) });
const getSubstituteCDNImage = transformSrc(getCDNImage);
const removeSizeExtFromSubstituteSrc = transformSrc(removeSizeExtFromImgSrc);
const pipe = (...actions) => (item) => actions.reduce((current, action) => action(current), item);

const sizeExtensionToSizeTokenMap = {
  '300x300': 'medium',
  '400x400': 'large',
  '200x200': 'thumb',
  thumb: 'thumb',
  src: 'full',
};

const DEFAULT_SIZE_TOKEN = 'large';

const getSizeTokenByExtension = (extension) => {
  if (extension === '') return sizeExtensionToSizeTokenMap.src;
  if (!extension || typeof extension !== 'string') return DEFAULT_SIZE_TOKEN;
  const extensionWithoutDot = extension?.replace('.', '');
  return sizeExtensionToSizeTokenMap[extensionWithoutDot] || DEFAULT_SIZE_TOKEN;
};

const getImgSize = (src, imgDimensions) => {
  if (!src || typeof src !== 'string') return [];

  const extension = src.match(/\.[^.]+$/)?.[0] || '';
  const sizeExtension = src.match(/\.(\d+x\d+|thumb)/i)?.[0] || '';
  const srcWithoutExtensions = src.replace(extension, '').replace(sizeExtension, '');
  const sizeToken = getSizeTokenByExtension(sizeExtension);
  return imgDimensions?.[srcWithoutExtensions]?.[sizeToken];
};

export const getGalleryMedia = (images, videos = [], thumbs, imageGallery, imgFormats, productName, imgDimensions) => {
  const getImgSubstitutes = createImgSubstitutesGetter(imgFormats);
  const galleryImages = images.map((image, index) => {
    const thumb = thumbs?.[index] || image;
    const large = removeSizeExtFromImgSrc(image);

    return {
      //Those are the fields needed by react-image-gallery
      //imageGallery variable contains replacement images with selected product options
      original: imageGallery || getCDNImage(image),
      originalSize: getImgSize(image, imgDimensions),
      originalSubstitutes: getImgSubstitutes(image).map(getSubstituteCDNImage),
      large: imageGallery || getCDNImage(large),
      largeSize: getImgSize(large, imgDimensions),
      largeSubstitutes: getImgSubstitutes(image).map(pipe(getSubstituteCDNImage, removeSizeExtFromSubstituteSrc)),
      thumbnail: getCDNImage(thumb),
      thumbnailSize: getImgSize(thumb, imgDimensions),
      thumbnailSubstitutes: getImgSubstitutes(thumb).map(getCDNImage),
      thumbnailLoading: 'lazy',
      originalAlt: productName,
      thumbnailAlt: productName + ' - thumbnail',
      originalTitle: productName,
      thumbnailTitle: productName + ' - thumbnail',
    };
  });

  const galleryVideos = videos.map((playbackId) => {
    return {
      playbackId,
      thumbnail: `https://image.mux.com/${playbackId}/thumbnail.png?width=80&height=80&time=6`,
      thumbnailLoading: 'lazy',
      originalAlt: productName,
      thumbnailAlt: productName + ' video - thumbnail',
      originalTitle: productName,
      thumbnailTitle: productName + ' video - thumbnail',
    };
  });

  const short = [...galleryImages.slice(0, 6), ...galleryVideos.slice(0, 1)];
  const full = [...galleryImages, ...galleryVideos];

  return {
    short: short.map((item, index) => ({ ...item, index })),
    full: full.map((item, index) => ({ ...item, index })),
  };
};
